<template>
  <div class="member-page">
    <div v-if="downloading" class="fixed inset-0 z-1001 flex items-center justify-center bg-black bg-opacity-30">
      <a-spin size="large" tip="下载中..." class="text-white" />
    </div>
    <a-spin :spinning="spinning" tip="正在导出...">
      <div class="overflow-hidden">
        <div>
          <a-card class="member-content" :bordered="false">
            <div>
              <div class="search-container">
                <div class="search-box-wrapper" :class="{ 'is-collapsed': isCollapsed }">
                  <div class="recommended-filters flex flex-wrap gap-4">
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">保函编号:</span>
                      <a-textarea style="width: 240px" :autoSize="{ minRows: 1, maxRows: 4 }" v-model="queryParam.like.code"
                        @pressEnter="press_enter"></a-textarea>
                    </div>
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">订单号:</span>
                      <a-textarea style="width: 240px" :autoSize="{ minRows: 1, maxRows: 4 }" v-model="queryParam.like.toubaono"
                        @pressEnter="press_enter"></a-textarea>
                    </div>
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">申请人:</span>
                      <a-textarea style="width: 240px" :autoSize="{ minRows: 1, maxRows: 4 }" v-model="queryParam.like.bidder"
                        @pressEnter="press_enter"></a-textarea>
                    </div>
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">项目名称:</span>
                      <a-textarea style="width: 240px" :autoSize="{ minRows: 1, maxRows: 4 }" v-model="queryParam.like.project"
                        @pressEnter="press_enter"></a-textarea>
                    </div>
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">下单/开标日期:</span>
                      <a-range-picker v-model="queryParam.time.kbdate" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" />
                    </div>
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">出函日期:</span>
                      <a-range-picker v-model="queryParam.time.sign_time" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" />
                    </div>
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">出函机构:</span>
                      <a-select style="width: 200px" allowClear autoSize v-model="selectedOrgan" placeholder="全部机构">
                        <a-select-option v-for="item in datasourceList" :key="item.name" :value="item.name">
                          {{ item.intr || item.name }}
                        </a-select-option>
                      </a-select>
                    </div>
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">保函状态:</span>
                      <a-select style="width: 200px" allowClear autoSize v-model="selectedStatus" placeholder="全部状态">
                        <a-select-option v-for="s in searchStatuses" :key="s.id" :value="s.id">{{ s.name }}</a-select-option>
                      </a-select>
                    </div>
                  </div>
                </div>
                <div class="search-actions">
                  <button class="px-2 text-blue-500 hover:text-blue-700 transition-colors flex items-center"
                    @click="toggleSearchBox" style="white-space: nowrap;">
                    <span class="px-1">{{ isCollapsed ? '展开' : '收缩' }}</span>
                    <a-icon :type="isCollapsed ? 'down' : 'up'" />
                  </button>
                  <a-button type="primary" @click="gets(1)"><a-icon type="search"></a-icon>搜索</a-button>
                  <a-button type="default" @click="reset" icon="reload">重置</a-button>
                </div>
              </div>
              <div class="member-actions flex flex-wrap justify-end gap-2 mb-4 mt-1">
                <a-button v-if="permission(['contract'], 'settle_apply')" type="primary" @click="settleApply">
                  <a-icon type="transaction" />清兑
                </a-button>
                <a-button v-if="permission(['contract'], 'addP')" type="primary" @click="AddFlagOn">
                  <a-icon type="plus-circle" />添加
                </a-button>
                <a-button v-if="permission(['contract'], 'exportReport')" class="member-secondary" @click="exportReport">
                  <a-icon type="file-excel" />报表导出
                </a-button>
                <a-button v-if="permission(['contract'], 'download')" class="member-secondary" @click="download">
                  <a-icon type="download" />下载
                </a-button>
              </div>
              <a-table :loading="loading" :columns="columns" :data-source="list" :pagination="pagination" bordered
                row-key="id" size="small">
                <template slot="status" slot-scope="text">
                  <span :class="findByKey(contractStatus, 'id', text, 'color')">{{
                    findByKey(contractStatus, 'id', text, 'name')
                  }}</span>
                </template>
                <template slot="code" slot-scope="text, record">
                  <text-highlight :queries="[search]" :title="text">
                    {{ record.prefix + text }}</text-highlight>
                </template>
                <template slot="proprietor" slot-scope="text">
                  <text-highlight :queries="[search]" :title="text"> {{ text }}</text-highlight>
                </template>
                <template slot="bidder" slot-scope="text">
                  <text-highlight :queries="[search]" :title="text"> {{ text }}</text-highlight>
                </template>
                <template slot="project" slot-scope="text">
                  <text-highlight :queries="[search]" :title="text">{{ text }}</text-highlight>
                </template>
              </a-table>
            </div>
            <Download :visible="downloadflag" @cancel="downloadflag = false" :queryparams="downloadQueryParam"
              :cateid="parseInt(1)" @downloadStart="handleDownloadStart" @downloadComplete="handleDownloadComplete">
            </Download>

            <AddPcontract :visible1.sync="AddFlag" @add-success="resetStatus()"></AddPcontract>

            <a-modal
              :visible="settleModalVisible"
              :title="settleModalTitle"
              :width="560"
              :confirm-loading="settleLoading"
              :closable="!syncingOrders && !settleLoading"
              :mask-closable="!syncingOrders && !settleLoading"
              @cancel="closeSettleModal"
            >
              <div class="settle-confirm">
                <div v-if="pendingSyncCount > 0" class="settle-confirm__notice">有 {{ pendingSyncCount }} 笔订单需要同步更新</div>
                <div v-if="syncTotal > 0" class="settle-confirm__notice">已完成 {{ syncCompleted }} / {{ syncTotal }} 笔</div>
                <div v-if="syncError" class="settle-confirm__notice">{{ syncError }}</div>
                <div v-if="!isSettleBlocked" class="settle-confirm__notice">{{ settleModalNotice }}</div>
                <div v-if="isSettleBlocked" class="settle-confirm__blocked">
                  <div class="settle-confirm__blocked-banner">
                    <div class="settle-confirm__blocked-head">
                      <div>
                        <div class="settle-confirm__blocked-title">检测到未入账订单</div>
                        <div class="settle-confirm__blocked-text">请先处理未入账保费后，再重新申请清兑。</div>
                      </div>
                    </div>
                  </div>
                  <div class="settle-confirm__stats">
                    <div class="settle-confirm__stat-row settle-confirm__stat-row--overview">
                      <span class="settle-confirm__stat-label">本次涉及订单</span>
                      <div class="settle-confirm__stat-values">
                        <div class="settle-confirm__stat-count">
                          <strong>{{ settleCount }}</strong>
                          <em>笔</em>
                        </div>
                      </div>
                    </div>
                    <div class="settle-confirm__stat-row">
                      <span class="settle-confirm__stat-label">已入账订单</span>
                      <div class="settle-confirm__stat-values settle-confirm__stat-values--stacked">
                        <div class="settle-confirm__stat-count">
                          <strong>{{ settleableCount }}</strong>
                          <em>笔</em>
                        </div>
                        <div class="settle-confirm__stat-extra">
                          <span class="settle-confirm__stat-extra-label">可清兑金额</span>
                          <div class="settle-confirm__stat-extra-value">
                            <strong>{{ settlePoundage }}</strong>
                            <em>元</em>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="settle-confirm__stat-row settle-confirm__stat-row--warn">
                      <span class="settle-confirm__stat-label">未入账订单</span>
                      <div class="settle-confirm__stat-values settle-confirm__stat-values--stacked">
                        <div class="settle-confirm__stat-count">
                          <strong>{{ unsettledPoundageCount }}</strong>
                          <em>笔</em>
                        </div>
                        <div class="settle-confirm__stat-extra">
                          <span class="settle-confirm__stat-extra-label">预计可清兑金额</span>
                          <div class="settle-confirm__stat-extra-value">
                            <strong>{{ unsettledExpectedPoundage }}</strong>
                            <em>元</em>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="zeroCommissionCount > 0" class="settle-confirm__stat-row">
                      <span class="settle-confirm__stat-label">无效订单</span>
                      <div class="settle-confirm__stat-values">
                        <div class="settle-confirm__stat-count">
                          <strong>{{ zeroCommissionCount }}</strong>
                          <em>笔</em>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="settle-confirm__summary">
                    <span>当前可清兑金额</span>
                    <div>
                      <strong>{{ settlePoundage }}</strong>
                      <em>元</em>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="settle-confirm__stats">
                    <div class="settle-confirm__stat-row settle-confirm__stat-row--overview">
                      <span class="settle-confirm__stat-label">本次涉及订单</span>
                      <div class="settle-confirm__stat-values">
                        <div class="settle-confirm__stat-count">
                          <strong>{{ settleCount }}</strong>
                          <em>笔</em>
                        </div>
                      </div>
                    </div>
                    <div class="settle-confirm__stat-row">
                      <span class="settle-confirm__stat-label">清兑订单</span>
                      <div class="settle-confirm__stat-values settle-confirm__stat-values--stacked">
                        <div class="settle-confirm__stat-count">
                          <strong>{{ settleableCount }}</strong>
                          <em>笔</em>
                        </div>
                        <!-- <div class="settle-confirm__stat-extra">
                          <span class="settle-confirm__stat-extra-label">可清兑金额</span>
                          <div class="settle-confirm__stat-extra-value">
                            <strong>{{ settlePoundage }}</strong>
                            <em>元</em>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div v-if="zeroCommissionCount > 0" class="settle-confirm__stat-row">
                      <span class="settle-confirm__stat-label">无效订单</span>
                      <div class="settle-confirm__stat-values">
                        <div class="settle-confirm__stat-count">
                          <strong>{{ zeroCommissionCount }}</strong>
                          <em>笔</em>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="settle-confirm__summary">
                    <span>当前可清兑金额</span>
                    <div>
                      <strong>{{ settlePoundage }}</strong>
                      <em>元</em>
                    </div>
                  </div>
                </div>
              </div>
              <template slot="footer">
                <a-button :disabled="syncingOrders || settleLoading" @click="closeSettleModal">取消</a-button>
                <a-button v-if="pendingSyncCount > 0 || syncNeedsRefresh" type="primary" :loading="syncingOrders" :disabled="settleLoading" @click="syncOrders">
                  {{ syncingOrders ? '正在同步，请稍候！' : '同步订单' }}
                </a-button>
                <a-button v-if="!isSettleBlocked" type="primary" :loading="settleLoading" :disabled="syncingOrders || syncNeedsRefresh || pendingSyncCount > 0 || !settleCount" @click="confirmSettle">提交清兑</a-button>
              </template>
            </a-modal>
          </a-card>
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { useColumn } from './_index';
import { exportContractsByPuser, contract_statuss } from '@/api/contract';
import { contractsByPuser } from '@/api/platform'
import { getUserBankInfo, applySettle, settlePreview, syncSettleOrder } from '@/api/business'

import permission from '@/utils/permission';
import { findByKey } from '@/utils/tool';
import Download from '@/views/admin/p_contract/module/download.vue';
import { isIE9 } from '@/utils/tool';
import { downloadUrl, downloadFilename, temporaryDownloadUrl } from '@/utils/download';
import { isSessionExpiredError } from '@/utils/session';

import AddPcontract from './module/AddPcontract.vue';


export default {
  components: {
    Download,
    AddPcontract
  },
  data() {
    return {
      AddFlag: false,
      isCollapsed: true,
      queryParam: { custom: { search: '' }, time: {}, in: {}, like: {}, eq: {} },
      downloadQueryParam: {},
      selectedOrgan:"",
      selectedStatus:"",
      columns: useColumn(),
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50'],
        showSizeChanger: true,
        onChange: (page, pageSize) => {
          this.pagination.current = page;
          this.pagination.pageSize = pageSize;
          this.gets();
        },
        onShowSizeChange: (current, size) => {
          this.pagination.current = current;
          this.pagination.pageSize = size;
          this.gets();
        },
        showTotal: (total) => this.formatTotalText(total),
      },
      loading: true,
      totalsLoading: false,
      requestVersion: 0,
      spinning: false,
      list: [],
      contractStatus: [],
      searchStatuses: [
        { id: 4, name: '待支付' },
        { id: 5, name: '已完成' },
        { id: 13, name: '已退保' },
        { id: 7, name: '已关闭' },
      ],
      datasourceList: [],
      downloadflag: false,
      search: '',
      is9: isIE9(),
      totalPoundage: 0,
      downloading: false,
      settleModalVisible: false,
      settleLoading: false,
      settlePreviewLoading: false,
      settleCount: 0,
      settleableCount: 0,
      settlePoundage: 0,
      zeroCommissionCount: 0,
      unsettledPoundageCount: 0,
      unsettledExpectedPoundage: 0,
      settleApplyQP: '',
      pendingSyncCount: 0, syncOrderIDs: [], syncingOrders: false,
      syncCompleted: 0, syncTotal: 0, syncError: '', syncNeedsRefresh: false, syncStopped: false,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),
    isSettleBlocked() {
      return Number(this.unsettledPoundageCount || 0) > 0;
    },
    settleModalTitle() {
      return this.isSettleBlocked ? '暂无法申请清兑' : '确认清兑';
    },
    settleModalNotice() {
      return this.isSettleBlocked ? '当前筛选结果中存在未入账订单' : '将按当前筛选条件提交清兑';
    },
  },
  beforeDestroy() { this.syncStopped = true; },
  deactivated() { this.syncStopped = true; },
  async mounted() {
    try {
      this.contractStatus = (await contract_statuss({ current: -1 })).data || [];
    } catch (error) {
      if (!isSessionExpiredError(error)) this.$message.error(error.message || String(error));
    }
  },
  activated() {
    if (this.userInfo && this.userInfo.is_black_user) {
      this.$router.replace('/admin/info');
      return;
    }
    this.gets();
  },
  methods: {
    toggleSearchBox() {
      this.isCollapsed = !this.isCollapsed;
    },
    permission,
    findByKey,
    getSearchQueryParam() {
      if (this.selectedOrgan) {
        this.queryParam.eq.data_source = this.selectedOrgan;
      } else {
        delete this.queryParam.eq.data_source;
      }
      if (this.selectedStatus !== '' && this.selectedStatus != null) {
        this.queryParam.in.status = [this.selectedStatus];
      } else {
        this.queryParam.in.status = null;
      }
      this.search = this.queryParam.custom.search;
      if (this.queryParam.like.toubaono) { this.queryParam.like.toubaono = this.queryParam.like.toubaono.replace(/\s/g, ''); }
      if (this.queryParam.like.bidder) { this.queryParam.like.bidder = this.queryParam.like.bidder.replace(/\s/g, ''); }
      if (this.queryParam.like.project) { this.queryParam.like.project = this.queryParam.like.project.replace(/\s/g, ''); }
      // Normalize only the request copy; keep the full guarantee code in the input.
      const query = { ...this.queryParam, like: { ...this.queryParam.like } };
      if (query.like.code) { query.like.code = query.like.code.replace(/\D/g, ''); }
      return JSON.stringify(query);
    },
    async gets(current) {
      this.loading = true;
      if (current) {
        this.pagination.current = current;
      }
      const qp = this.getSearchQueryParam();
      const version = ++this.requestVersion;
      try {
        const res = await contractsByPuser({
          current: this.pagination.current,
          pageSize: this.pagination.pageSize,
          // Render the columns visible in this table first. Aggregates and
          // the institution filter are fetched after the rows are painted.
          web_list: 1,
          include_total: 0,
          qp,
        });
        if (version !== this.requestVersion) return;
        this.list = res.data || [];
        this.loadTotals(qp, version);
      } catch (error) {
        if (!isSessionExpiredError(error)) this.$message.error(error.message || String(error));
      } finally {
        if (version === this.requestVersion) this.loading = false;
      }
    },
    async loadTotals(qp, version) {
      this.totalsLoading = true;
      // Yield once so Vue can paint the table before the database aggregate
      // starts on a large shared-enterprise order scope.
      setTimeout(async () => {
        try {
          const res = await contractsByPuser({
            current: 1,
            pageSize: 1,
            web_list: 1,
            include_total: 1,
            include_sum: 1,
            include_datasources: 1,
            qp,
          });
          if (version !== this.requestVersion) return;
          this.totalPoundage = res.sum || 0;
          this.datasourceList = res.data_sources || [];
          this.$set(this.pagination, 'total', res.total || 0);
        } catch (e) {
          // The table is already usable. A later search or page change retries
          // its optional aggregate data without replacing visible rows.
        } finally {
          if (version === this.requestVersion) this.totalsLoading = false;
        }
      }, 0);
    },
    formatTotalText(total) {
      if (this.totalsLoading) {
        return '统计中…';
      }
      if (!total) {
        return '';
      }
      return `合计担保费: ${this.totalPoundage}元 | 共 ${total} 条数据`;
    },
    resetStatus() {
      this.selectedOrgan = null;
      this.gets();
    },
    reset() {
      this.queryParam = { custom: { search: '' }, time: {}, in: {}, like: {}, eq: {} };
      this.selectedOrgan=null;
      this.selectedStatus=null;
      this.gets(1);
    },

    async exportReport() {
      this.spinning = true;
      try {
        const url = await exportContractsByPuser({
          qp: this.getSearchQueryParam(),
        });
        await downloadUrl(
          temporaryDownloadUrl(url),
          downloadFilename('推荐订单报表', 'xlsx'),
        );
      } catch (error) {
        if (!isSessionExpiredError(error)) this.$message.error('报表导出失败：' + (error.message || String(error)));
      } finally {
        this.spinning = false;
      }
    },
    download() {
      this.downloadQueryParam = JSON.parse(this.getSearchQueryParam());
      this.downloadflag = true;
    },
    AddFlagOn() {
      this.AddFlag = true


    },
    handleDownloadStart() {
      this.downloading = true;
    },
    handleDownloadComplete() {
      this.downloading = false;
    },
    press_enter(e) {
      e.preventDefault();
      this.gets(1);
    },
    async settleApply() {
      this.settlePreviewLoading = true;
      try {
        const bankInfo = await getUserBankInfo();
        if (!bankInfo.has_bank_info) {
          this.$message.warning('请先前往"我的信息"完善真实姓名、开户行和银行账号信息');
          return;
        }
        const qp = this.getSearchQueryParam();
        const preview = await settlePreview({ qp });
        if (!preview.count) {
          this.$message.warning('没有符合清兑条件的订单');
          return;
        }
        this.settleApplyQP = qp;
        this.updateSettlePreview(preview);
        this.syncCompleted = 0;
        this.syncTotal = 0;
        this.syncError = '';
        this.syncNeedsRefresh = false;
        this.settleModalVisible = true;
      } catch (e) {
        if (!isSessionExpiredError(e)) this.$message.warning(e.message || '获取清兑信息失败');
      } finally {
        this.settlePreviewLoading = false;
      }
    },
    closeSettleModal() {
      if (!this.syncingOrders && !this.settleLoading) this.settleModalVisible = false;
    },
    updateSettlePreview(preview) {
      this.settleCount = preview.count;
      this.settleableCount = Number(preview.settleable_count == null ? 0 : preview.settleable_count);
      this.settlePoundage = preview.total_poundage;
      this.zeroCommissionCount = Number(preview.zero_commission_count == null ? 0 : preview.zero_commission_count);
      this.unsettledPoundageCount = Number(preview.unsettled_poundage_count == null ? 0 : preview.unsettled_poundage_count);
      this.unsettledExpectedPoundage = Number(
        preview.unsettled_expected_poundage == null ? 0 : preview.unsettled_expected_poundage,
      );
      this.pendingSyncCount = Number(preview.pending_sync_count || 0);
      this.syncOrderIDs = preview.sync_order_ids || [];
    },
    async syncOrders() {
      if (this.syncingOrders || this.settleLoading) return;
      this.syncingOrders = true;
      this.syncStopped = false;
      this.syncError = '';
      this.syncCompleted = 0;
      this.syncNeedsRefresh = true;
      let sessionExpired = false;
      try {
        this.updateSettlePreview(await settlePreview({ qp: this.settleApplyQP }));
        const ids = [...this.syncOrderIDs];
        this.syncTotal = ids.length;
        for (const id of ids) {
          if (this.syncStopped) throw new Error('同步已暂停，请重新核算后继续同步');
          await syncSettleOrder({ id, qp: this.settleApplyQP });
          this.syncCompleted += 1;
        }
      } catch (e) {
        sessionExpired = isSessionExpiredError(e);
        if (sessionExpired) this.settleModalVisible = false;
        else this.syncError = e.message || String(e) || '同步失败，请重新核算后继续同步';
      } finally {
        if (!sessionExpired) {
          try {
            this.updateSettlePreview(await settlePreview({ qp: this.settleApplyQP }));
            this.syncNeedsRefresh = false;
          } catch (e) {
            sessionExpired = isSessionExpiredError(e);
            if (sessionExpired) this.settleModalVisible = false;
            else this.syncError = '重新核算失败，请再次点击同步订单或关闭后重新核算';
          }
        }
        this.syncingOrders = false;
        if (!sessionExpired) this.gets();
      }
    },
    async confirmSettle() {
      if (this.syncingOrders || this.settleLoading || this.syncNeedsRefresh || this.pendingSyncCount > 0 || this.isSettleBlocked || !this.settleCount) return;
      this.settleLoading = true;
      try {
        const res = await applySettle({ qp: this.settleApplyQP || this.getSearchQueryParam() });
        this.$message.success(`已提交 ${res.count || 0} 笔清兑申请`);
        this.settleModalVisible = false;
        this.gets(1);
      } catch (e) {
        if (isSessionExpiredError(e)) this.settleModalVisible = false;
        else this.$message.error(e.message || String(e) || '申请失败');
        this.syncNeedsRefresh = true;
      } finally {
        this.settleLoading = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.action {
  vertical-align: baseline !important;
}

@import '~@/style/search-toolbar.less';

.search-box-wrapper {
  min-height: 45px;
  overflow: visible;

  &.is-collapsed .recommended-filters > div:nth-child(n + 4) {
    display: none;
  }
}

.recommended-filters {
  margin: -3px;
  padding: 3px;
}

.z-1001 {
  z-index: 1001;
}

.bg-opacity-30 {
  opacity: 0.3;
}

.settle-confirm {
  padding: 4px 0 2px;
}

.settle-confirm__notice {
  margin-bottom: 14px;
  padding: 10px 12px;
  color: #4b5563;
  background: #f6f8fb;
  border: 1px solid #e8edf5;
  border-radius: 6px;
}

.settle-confirm__stats {
  overflow: hidden;
  background: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 8px;
}

.settle-confirm__blocked-banner {
  margin-bottom: 12px;
  padding: 14px 16px;
  color: #9a6700;
  background: linear-gradient(180deg, #fff9ec 0%, #fff4dd 100%);
  border: 1px solid #ffe2a8;
  border-radius: 8px;
}

.settle-confirm__blocked-title {
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: 600;
}

.settle-confirm__blocked-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.settle-confirm__blocked-text {
  font-size: 13px;
  line-height: 1.7;
}

.settle-confirm__stat-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border-bottom: 1px solid #eef2f7;
}

.settle-confirm__stat-row:last-child {
  border-bottom: 0;
}

.settle-confirm__stat-row--overview {
  padding-top: 16px;
  padding-bottom: 16px;
  background: linear-gradient(180deg, #f8fbff 0%, #f3f8ff 100%);
}

.settle-confirm__stat-row--overview .settle-confirm__stat-label {
  color: #334155;
  font-weight: 600;
}

.settle-confirm__stat-row--overview .settle-confirm__stat-count strong {
  color: #0f172a;
  font-size: 22px;
}

.settle-confirm__stat-label {
  color: #4b5563;
  font-size: 13px;
}

.settle-confirm__stat-values {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  flex-wrap: wrap;
}

.settle-confirm__stat-values--stacked {
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.settle-confirm__stat-count {
  white-space: nowrap;
}

.settle-confirm__stat-count strong {
  color: #111827;
  font-size: 22px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.settle-confirm__stat-count em {
  margin-left: 6px;
  color: #6b7280;
  font-style: normal;
  white-space: nowrap;
}

.settle-confirm__stat-extra {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: #f6f8fb;
  border: 1px solid #e7eaf0;
  border-radius: 999px;
  white-space: nowrap;
}

.settle-confirm__stat-extra-label {
  color: #6b7280;
  font-size: 12px;
}

.settle-confirm__stat-extra-value strong {
  color: #1f2937;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
}

.settle-confirm__stat-extra-value em {
  margin-left: 4px;
  color: #6b7280;
  font-style: normal;
}

.settle-confirm__stat-row--warn {
  background: #fff7e6;
}

.settle-confirm__stat-row--warn .settle-confirm__stat-count strong {
  color: #d97706;
}

.settle-confirm__stat-row--warn .settle-confirm__stat-extra {
  background: #fff3d6;
  border-color: #f6d7a7;
}

.settle-confirm__stat-row--warn .settle-confirm__stat-extra-label {
  color: #b45309;
}

.settle-confirm__stat-row--warn .settle-confirm__stat-extra-value strong {
  color: #d97706;
}

.settle-confirm__stat-row--warn .settle-confirm__stat-amount {
  color: #b45309;
}

.settle-confirm__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding: 14px 16px;
  background: #f7fbff;
  border: 1px solid #cfe4ff;
  border-radius: 8px;
}

.settle-confirm__summary span {
  color: #4b5563;
  font-size: 13px;
}

.settle-confirm__summary strong {
  color: #0960bd;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}

.settle-confirm__summary em {
  margin-left: 6px;
  color: #6b7280;
  font-style: normal;
}
</style>
